import { Component, Fragment, h, JSX, Prop } from "@stencil/core";
import { isString } from "@phn/utility/helper";

@Component({
  tag: "phn-nd-signature-heading",
  styleUrl: "signature-heading.scss",
  scoped: true,
})
export class SignatureHeading {
  @Prop() text!: string;

  @Prop() subtext?: string;

  render(): JSX.Element {
    return (
      <Fragment>
        <phn-p-model-signature
          model={this.text.toLowerCase()}
          size="inherit"
          class="model-signature"
        >
          {/* Fix: this is for Windows Chrome in order to display the correct color for the masked svg. Otherwise, the signature would be a box with the background-color */}
          <div
            style={{
              backgroundColor: "black",
              height: "calc(100% + 1px)",
              width: "100%",
            }}
          ></div>
        </phn-p-model-signature>

        {isString(this.subtext) ? (
          <phn-p-text
            color="inherit"
            class="subtext"
            weight="regular"
            size="x-small"
            tag="div"
            ellipsis="true"
            data-test-id="subtext"
          >
            {this.subtext}
          </phn-p-text>
        ) : null}
      </Fragment>
    );
  }
}
